module.exports = __webpack_public_path__ + "img/FIRST DELRAY.dbfbb330.png";